import Spinner from '@/components/Spinner';

import * as styles from '@/styles/components/Loading';

const Loading = () => {
  return (
    <div css={styles.root}>
      <Spinner size='lg' />
    </div>
  );
};

export default Loading;
